/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { PsfUser } from '@scenario/models/psf-user.model';
import { RootState } from '@store/create-store';
import {
  retrievePsfUsers,
  retrievePsfUsersFailure,
  retrievePsfUsersSuccess,
} from '@store/scenario/analyst/analyst-slice';

export const retrievePsfUsersEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) => action$.pipe(
  ofType(retrievePsfUsers.type),
  concatMap(() => from(dependencies.psfUserGateway.retrieveAll()).pipe(
    map((users: PsfUser[]) => retrievePsfUsersSuccess(users)),
    catchError(() => of(retrievePsfUsersFailure('Failed to retrieve users'))),
  )),
);
